import {
  useState,
  useEffect,
  Fragment,
  type FC,
} from 'react';
import {
  Link
} from 'react-router-dom';
import {
  Button
} from '@mui/joy';
import {
  type ButtonProps
} from './types';

export interface LinkButtonProps extends Omit<ButtonProps, 'onClick'> {
  target?: string;
};

export const LinkButton: FC<LinkButtonProps> = ({
  children,
  target,
  ...props
}) => {

  /**
   * In React 18, during development mode (especially in projects using Vite, CRA, and similar tools), 
   * server-side rendering is emulated: "server-like" HTML is generated first, and then checked against 
   * the client-rendered HTML. Even without real SSR, this helps catch hydration errors early, ensuring 
   * the application remains compatible with SSR in the future
  */
  const [isClient, setIsClient] = useState<boolean>(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Fragment>
      {isClient && (
        <Button
          target={target}
          component={Link}
          {...props}>
          {children}
        </Button>
      )}
    </Fragment>
  );
};

